$(function () {
  $('.js-kvSlide').slick({
    centerMode: true,     // 中央寄せ表示
    centerPadding: '25%', // 左右の見せたい部分の幅（%またはpx）
    slidesToShow: 1,      // 表示スライド数（中央の1枚）
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          centerPadding: '10%',  // スマホ時にpaddingを狭める
        }
      },
      {
        breakpoint: 750,
        settings: {
          centerPadding: '10%',  // ≤750: 中央スライド約80%＋左右を約10%ずつチラ見せ
        }
      }
    ]
  });
});